import { AbstractType, InjectFlags, InjectionToken, Injector, Type } from '@angular/core';

export class DialogInjector implements Injector {

    constructor(
        private injector: Injector,
        private ownTokens: WeakMap<any, any>
    ) { }

    get<T>(token: Type<T> | InjectionToken<T> | AbstractType<T>, notFoundValue?: T, flags?: InjectFlags): T;
    get(token: any, notFoundValue?: any);

    get(token: any, notFoundValue?: any, flags?: any) {
        console.log('[bcd] DialogInjector - token: ', token);
        console.log('[bcd] DialogInjector - notFoundValue: ', notFoundValue);
        console.log('[bcd] DialogInjector - flags: ', flags);
        console.log('[bcd] DialogInjector - this.ownTokens.get(token): ', this.ownTokens.get(token));


        return this.ownTokens.get(token) || this.injector.get<any>(token, notFoundValue);
    }
}
